import React from 'react'
import PaymentIcon from 'react-payment-icons'
import { Typography } from 'antd'
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';

export const PaymentCard = ({ card, showBorder = true }) => (
  <div
    className="cc-card"
    style={showBorder ? { border: '1px solid #efefef' } : {}}
  >
    {card.card.brand === 'visa' && <FaCcVisa className="cc-card-icon" />}
    {card.card.brand === 'mastercard' && <FaCcMastercard className="cc-card-icon" />}
    <div className="cc-card-info">
      <Typography.Text>
        <span style={{ textTransform: 'capitalize' }}>{card.card.brand} </span>
        card ending in {card.card.last4}
      </Typography.Text>
      <Typography.Text type="secondary">
        Expiry {card.card.exp_month}/{card.card.exp_year}
      </Typography.Text>
    </div>
  </div>
)
